import { Link } from "react-router-dom";

export default function BookingCanceled() {
  return (
    <div className="min-h-screen grid place-items-center bg-[color:var(--bg-primary)] px-6" data-testid="booking-canceled-page">
      <div className="max-w-xl text-center">
        <Link to="/" className="font-heading text-3xl block mb-10">Dentainhoa<span className="text-[color:var(--accent)]">.</span></Link>
        <div className="text-xs uppercase tracking-[0.28em] text-[color:var(--text-secondary)] mb-4">Pago cancelado</div>
        <h1 className="font-heading text-5xl md:text-6xl italic tracking-tighter mb-6">Sin problema.</h1>
        <p className="text-[color:var(--text-secondary)] mb-8">Has cancelado el depósito. Puedes reintentar cuando quieras, tu solicitud sigue guardada.</p>
        <Link to="/#cita" className="inline-flex items-center gap-2 rounded-full bg-[color:var(--text-primary)] text-[color:var(--bg-primary)] px-6 py-3 text-sm">Volver a la reserva</Link>
      </div>
    </div>
  );
}
